<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                    <SummeryCnt v-bind:scnt1=scnt1 v-bind:scnt2=scnt2  v-bind:scnt3=scnt3  v-bind:scnt4=scnt4 
                    v-bind:summeryTtile=summeryTtile  v-bind:summeryTtile1=summeryTtile1  v-bind:summeryTtile2=summeryTtile2  v-bind:summeryTtile3=summeryTtile3 v-bind:summeryTtile4=summeryTtile4  />
                    <v-card elevation="1" class="mt-3" >
                        <div class="d-flex pt-3" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Registration Date</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu 
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :return-value.sync="s_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            v-model="s_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="d-flex align-self-center mt-0 pt-0"
                                            style="font-size:13px; "
                                            placeholder="Start Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="s_date" no-title scrollable :max="e_date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="s_date_search(s_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="e_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="220px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="e_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="align-self-center ma-0 pa-0"
                                            style="font-size:13px;width:190px;"
                                            placeholder="End Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="e_date" no-title scrollable :min="s_date" :max="date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="e_date_search(e_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex" >
                                    <v-btn-toggle v-model="toggleMonthBtn" class="pt-4">
                                        <v-btn small class="ml-1" @click="setSchDate(1)">Today</v-btn>
                                        <v-btn small  @click="setSchDate(2)">1 Month</v-btn>
                                        <v-btn small  @click="setSchDate(3)">All</v-btn>
                                    </v-btn-toggle>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Classification</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <!--
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schCountryCode" :items="countryList" item-text="info" item-value="vals" label="National" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                <div class="d-flex pr-5" style="width:200px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schAgencyCode" :items="agencyList" item-text="info" item-value="vals" label="Agency" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schDvcClass" :items="DeivceClsList" item-text="info" item-value="vals" label="Devices" outlined dense single-line hide-details>
                                    </v-select>
                                </div>     
                                -->      
                                <div class="d-flex pr-5" style="width:100%;min-width:180px;max-width:220px; ">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schBssSeq" :items="schBssList" item-text="info" item-value="vals" label="BSS Name" outlined dense single-line hide-details>
                                    </v-select>
                                </div>                                          
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schChargerStatus" :items="chargerStatusList" item-text="info" item-value="vals" label="Charger Status" outlined dense single-line hide-details>
                                    </v-select>
                                </div>                                               
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schAprvStatus" :items="approvalList" item-text="info" item-value="vals" label="Use Status" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Keyword</div>
                            <div class="d-flex" style="width:100%;">
                                <div class="d-flex pt-2 pr-auto" style="width:557px;">
                                    <v-text-field v-model="schText" outlined dense single-line hide-details small clearable placeholder="Charger ID"></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex pb-5 justify-center" style="width:100%;">
                            <v-btn class="schClearBtn" small dark @click="searchFormReset()">Clear </v-btn>
                            <v-btn class="ml-2 schBtn" small dark @click="getList()">Search</v-btn>
                        </div>
                    </v-card>
                    <v-card elevation="1" class="mt-3">
                        <div class="d-flex flat pa-5" elevation="0" >
                            <div class="mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="listCnt">{{listTotalCnt}}</span></div>
                            <div class="pr-2">
                                <!-- 
                                    unlock - 충전기상태:  1(대기) / mqtt : disagree$$ 
                                    charge - 충전기상태: 2(충전시작(충전중) / mqtt : charge$$
                                -->
                                <v-btn color="teal" small style="color:#FFF;"  class="ml-2" @click="setAprvStatus('91')">Charger Unlock</v-btn>
                                <v-btn color="indigo" small  style="color:#FFF;"  class="ml-2 " @click="setAprvStatus('92')">Charger Charge</v-btn>
                                <v-btn color="red" small  style="color:#FFF;"  class="ml-2 mr-10" @click="setAprvStatus('93')">Charger Reset</v-btn>


                                <!-- 승인상태(1:입고, 2:수리중, 3:검수중, 4:승인반려, 5:승인대기, 6:승인완료) -->
                                <!--
                                <v-btn color="grey" small outlined class="ml-2" @click="setAprvStatus('1')">Incoming</v-btn>
                                <v-btn color="warning" small outlined class="ml-2" @click="setAprvStatus('2')">Repair</v-btn>
                                <v-btn color="accent" small outlined class="ml-2" @click="setAprvStatus('3')">Reception</v-btn>
                                -->
                                <v-btn color="red" small outlined class="ml-2" @click="setAprvStatus('1')">Charger Disabled</v-btn>
                                <!--<v-btn color="teal" small  outlined class="ml-2" @click="setAprvStatus('5')">Ready</v-btn>-->
                                <v-btn color="indigo" small  outlined  class="ml-2" @click="setAprvStatus('2')">Charger Enabled</v-btn>
                            </div> 
                        </div>
                        <div>
                            <table style="width:100%;" cellspacing="0" cellpadding="0" class="px-5">
                                <tr class="listHeader">
                                    <th style="width:20px"><v-checkbox class="align-self-center pl-2 ma-0" hide-details color="white" dark @click="checkedAll" v-model="allSelected"></v-checkbox></th>
                                    <th style="width:20px">No</th>
                                    <!--
                                    <th style="width:10%">National</th>
                                    <th style="width:12%">Agency</th>
                                    -->
                                    <th style="width:15%">BSS Name</th>
                                    <th style="">Address</th>
                                    <!--<th style="width:12%">Model</th>-->
                                    <th style="width:10%">Charger ID</th>
                                    <th style="width:10%">Charger Status</th>
                                    <th style="width:10%">Charger Use</th>
                                    <th style="width:12%">Battery ID1 (SOC)</th>
                                    <th style="width:12%">Battery ID1 (SOC)</th>
                                    <th style="width:12%">Updated Datetime</th>
                                </tr>
                                <tr v-for="(item, index) in bssList" :key="item.CHRG_ID">
                                    <td class="rowList"><v-checkbox v-model="selectBssChrgID" class="align-self-center pl-2 ma-0" hide-details  :value=item.CHRG_ID @click="selected()"></v-checkbox></td>
                                    <td class="rowList">{{(listTotalCnt - (page -1) * 10) - index}}</td>
                                    <!--
                                    <td class="rowList">{{item.NAT_NAME}}</td>
                                    <td class="rowList">{{item.AGENCY_NAME}}</td>
                                    -->
                                    <td class="rowList " >{{item.BSS_NM}}</td>
                                    <td class="rowList text-left">{{item.ADDR}}</td>
                                    <!--<td class="rowList">{{item.CHRG_MODEL}}</td>-->
                                    <td class="rowList"><span style="color:#1976D2;cursor:pointer;" @click="viewInfo(item.BSS_SEQ, item.CHRG_ID)">{{item.CHRG_ID}}</span></td>
                                    
                                    <td class="rowList"><!--{{ item.CHRG_STATUS }}-->
                                        <span v-if="item.CHRG_STATUS==='9'" style='color:#AD1457; padding-left:5px'>{{item.CHRG_STATUS_INFO}}</span>
                                        <span v-else-if="item.CHRG_STATUS==='2'" style='color:#1976D2; padding-left:5px'>{{item.CHRG_STATUS_INFO}}</span>
                                        <span v-else style='padding-left:5px'>{{item.CHRG_STATUS_INFO}}</span>
                                    </td>
                                    <td class="rowList">
                                        <span v-if="item.MNG_INFO==='Disabled'" style='color:#AD1457; padding-left:5px'>{{item.MNG_INFO}}</span>
                                        <span v-else style='color:green; padding-left:5px'>{{item.MNG_INFO}}</span>
                                    </td>               
                                    <td class="rowList">
                                        {{item.CELL_ID1}} 
                                        <span v-if="item.CELL_ID1 !==null && item.CELL_ID1 !==''">({{ item.CELL_CHRG_GAGE1 }}%)</span>
                                        <span v-else> - </span>
                                    </td>
                                    <td class="rowList">
                                        {{item.CELL_ID2}}
                                        <span v-if="item.CELL_ID2 !==null && item.CELL_ID2 !==''">({{ item.CELL_CHRG_GAGE2 }}%)</span>
                                        <span v-else> - </span>                                        
                                    </td>
                                    <td class="rowList">{{item.UPD_DTM}}</td>
                                </tr>
                                <tr v-if="emptyFlag=='Y'">
                                    <td colspan="8" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </table>
                            <div class="pa2" v-if="listTotalCnt>0">
                                <div class="text-center mt-5">
                                    <Paging v-if="listTotalCnt>0" :currentPage="page" :key="listTotalCnt" :totalPages="pagelength"  :totalCount="listTotalCnt" @onPageChange="onPageChange" />
                                </div>
                            </div>
                            <div class="d-flex justify-space-between dense pa-5">
                                <div class="pa2 pl-2 " ><v-btn class="excelBtn" dark @click="downExcel">Excel Download</v-btn></div>
                                <div class="pa2 pr-2">
                                  <!--  <v-btn  dark class="ml-2 excelBtn">Excel Registration</v-btn> -->
                                    <v-btn  dark class="ml-2 registerBtn" @click="registerVehicle">New Registration</v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <!-- alert: not checked -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="chkListFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-alert </v-icon>
                        <span class="pl-3">Please select a Charger  </span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="chkListFlag = false">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        
        <!--<ErrorDialog v-on:childEvent="closeErrorDialog" />-->

        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Success')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Error')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    /*.theme--light.v-btn.v-btn--has-bg {background-color: #1e2c3c !important; color:#fff}*/
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import SummeryCnt from '@/components/summeryCnt.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import Paging from '@/components/paging.vue'

import dayjs from 'dayjs'

export default {
    name: 'Bss',
    components: { Gnb, Footer, SummeryCnt, Navs, PageCrumbs, Paging },

    data () {
        return {
            // login Info
            gnbCode:"3", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "BSS & Charger List",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'BSS', disabled: true,}, { text: 'BSS Management', disabled: true,}, { text: 'BSS & Charger List', disabled: false,}],
            NavList: [ 
                        { title: 'BSS & Charger Management', nums: '1',
                            items: [ { title: 'BSS & Charger List', nums:11, href:'/Bss' , icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/BssWrite', icons:'mdi-lead-pencil' },],
                        },
                        { title: 'Charger Log', nums: '2',
                            items: [ { title: 'Charger Log',nums:21, href:'/BssLog', icons:'mdi-format-list-bulleted' },],
                        },
                    ],     

            // Summery title & Count
            scnt1:"0", scnt2:"0", scnt3:"0", scnt4:"0", summeryTtile:"등록현황", summeryTtile1:"Total", summeryTtile2:"Ready", summeryTtile3:"Error", summeryTtile4:"Disconnected",
            
            // List count & Pagination 
            listTotalCnt: 0, page: 0, pagelength:0, bssList:[],
            emptyFlag: 'Y',

            // Datepicker & Short button
            date: new Date().toISOString().substr(0, 10), 
            s_date: "", e_date: "", menu1: false, menu2: false,
            toggleMonthBtn:2,
            // Search form : select 
            countryList: [{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}],
            agencyList: [{info:"indonesia charger", vals:2},{info:"E3Mobility",vals:3}, {info:"Others",vals:4}],
            factoryList: [{info: '현대캐피코', vals: 4}, {info: 'LG에너지솔루션', vals: 5}, {info: '풍산시스템', vals: 6}, {info: '보다폰', vals: 7}],
            modelList: [{info:'E3_BLADE', vals:1}],
            //approvalList: [{info: 'Incoming', vals: 1}, {info: 'Repair', vals: 2}, {info: 'Reception', vals: 3}, {info: 'Disapproval', vals: 4}, {info: 'Ready', vals: 5}, {info: 'Approval', vals: 6} ],
            approvalList: [{info: '- ALL -', vals: ""}, {info: 'Disable', vals: 1}, {info: 'Enable', vals: 2} ],
            //DeivceClsList: [{info: 'VCU', vals: 1}, {info: 'MCU', vals: 2}, {info: 'BMS', vals: 3}, {info: 'Charger', vals: 4}, {info: 'LTE', vals: 5}],
            chargerStatusList: [{info: '- ALL -', vals: ""}, {info: 'Charging', vals: 2}, {info: 'Error', vals: 9}, {info: 'Booking', vals: 6} ],
            schCountryCode: "", schfactoryCode:"", schfModelNum:"", schAprvStatus:"", schText:"", schDvcClass: "", schAgencyCode: "", schChargerStatus: "",
            
            schBssSeq: "", schBssList: [],

            // Checkbox
            selectBssChrgID:[], allSelected: false,
            // Async & Modify Result
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        this.page = 1;
        this.getList( this.page);
        localStorage.removeItem("schBssSeq");
        localStorage.removeItem("schBssChrgID");
        this.getBSSName();
    },

    methods : {
        getBSSName() {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/cfg_bss.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                // console.log(json);
                //console.log(json.result);
                if(json.result == "success") {
                    this.schBssList =[];
                    this.schBssList = json.value.list;  
                } else {
                    this.schBssList = [];
                }
            }).catch(() => {
                //console.log(error);
                //this.$router.replace('Error');
                //this.schBssList = [];
            });
        },


        // datepicker 
        setSchDate(arg) {
            if(arg == 1) {
                this.s_date = new Date().toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 2) {
                let now = new Date();
                this.s_date =  new Date(now.setMonth(now.getMonth() - 1));
                this.s_date = this.s_date.toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 3) {
                this.s_date = '';
                this.e_date = '';
            }
        },

        // datepicker - sub
        s_date_search(v) {
            this.s_date = v;
            this.menu1 = false;
            this.$refs.menu1.save(v);
        },

        // datepicker - sub
        e_date_search(v) {
            this.e_date = v;
            this.menu2 = false;
            this.$refs.menu2.save(v);
        },

        // search form reset
        searchFormReset() {
            this.s_date=""; this.e_date="";
            this.schCountryCode=""; this.schfactoryCode="";  this.schfModelNum=""; this.schAprvStatus=""; this.schText=""; this.schDvcClass="";
            this.schAgencyCode=''; this.schChargerStatus=""; this.schBssSeq="";
            this.page = 1;
            this.getList(this.page);

        },

        getPageList() {
            //console.log(this.page);
            this.getList(this.page);
        },

        // API Async 
        getList(page) {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "L"
                    , "page":page
                    , "schAprvStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schAgencyCode": this.schAgencyCode
                    , "schDvcClass": this.schDvcClass
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                    , "schChargerStatus": this.schChargerStatus
                    , "schBssSeq": this.schBssSeq
                })
            };
           
            //console.log(requestOptions.body );
           
            fetch('https://api.e3bss.com/_APP/POC/bssInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                console.log(json );
                //console.log(json.result);
                if(json.result == "success") {
                    this.bssList =[];
                    this.bssList = json.value.list;
                    this.listTotalCnt = Number(json.totalCnt);
                    this.pagelength = json.totalPage;
                    this.page = json.currentPage;
                    this.emptyFlag = "N";
                } else {
                    this.bssList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                    this.pagelength = 0;
                }
                this.scnt1 = json.cnt1; this.scnt2 = json.cnt2; this.scnt3 = json.cnt3; this.scnt4 = json.cnt4;
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
                this.bssList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                    this.pagelength = 0;
            });
        },

        // Approve Status Modify
        setAprvStatus(vals) {
            //console.log(this.selectBssChrgID.length + "/"+ this.selectBssChrgID);
            if(vals != '' && this.selectBssChrgID.length > 0) {
                this.chkListFlag = false;
                this.modifyApprove(vals);
            } else {
                this.chkListFlag = true;
            }
        },

        // API Async: Status Update
        modifyApprove(arg) {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "LU"
                    , "bssChrgIdArr": this.selectBssChrgID
                    , "bssChrgStatus": arg
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/bssInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.getList(1);
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                } else {
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
            }).catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        }, 

        registerVehicle() {
            this.$router.push('BssWrite');
        },
        
        viewInfo(seq, arg) {
            //console.log(seq + " / "+ arg);
            localStorage.setItem("schBssSeq", seq);
            localStorage.setItem("schBssChrgID", arg);
            this.$router.push({ name: 'BssDetail', params: { Seq: seq, ChrgID: arg }})
        },

        checkedAll() {
            //console.log('click');
            this.selectBssChrgID = [];
            if (this.allSelected) {
                for (let bss in this.bssList) {
                    this.selectBssChrgID.push(this.bssList[bss].CHRG_ID.toString());
                }
            }
        },

        selected: function() {
            this.allSelected = false;
        }, 
        
        closeDialog(cls) {
            if(cls == "Success") {
                this.asyncSuccess = false;
            } else if(cls == "Error") {
                this.asyncErrors = false;
            }
            this.selectBssChrgID = [];
            this.allSelected=false;
        },
        
        onPageChange(param) {
            //console.log("onPageChange="+param);
            this.page = Number(param);
            //console.log("this.page="+Number(this.page));
            this.getList(this.page);
        },

        downExcel() {
            const xlsx = require("xlsx");
            // 엑셀 파일 생성
            const sheets = xlsx.utils.book_new();
            // data get > 실 개발시 api 호출
            
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "EL"
                    , "schAprvStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schAgencyCode": this.schAgencyCode
                    , "schDvcClass": this.schDvcClass
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/bssInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                //console.log(json );
                //console.log(json.list );
                if(json.result == "success") {
                    /*
                    const excelData = json.value.list;
                    const worksheetData = xlsx.utils.json_to_sheet(excelData);
                    xlsx.utils.book_append_sheet(sheets, worksheetData, "Data");
                    let nowDTM =  dayjs().format("YYYYMMDDHHmmss");
                    xlsx.writeFile(sheets, "ChargerStationList_"+nowDTM+".xlsx");
                    */
                    const excelData = json.value.list;
                    const worksheetData = xlsx.utils.json_to_sheet(excelData);
                    // 각 컬럼의 최대 길이 계산
                    const columnWidths = Object.keys(excelData[0]).map((key) => ({
                        wch: Math.max(
                            key.length, // 헤더 길이
                            ...excelData.map((row) => (row[key] ? row[key].toString().length : 0)) 
                        )
                    }));
                    worksheetData["!cols"] = columnWidths; // 셀 너비 적용
                    xlsx.utils.book_append_sheet(sheets, worksheetData, "Data");
                    let nowDTM = dayjs().format("YYYYMMDD_HHmmss");
                    xlsx.writeFile(sheets, "BSS & Charger List " + nowDTM + ".xlsx");
                } else {
                   //alert("Error");
                   this.$router.replace('Error');
                }
                
            }).catch((error) => {
                console.log(error);
                this.$router.replace('Error');
            });
           
        },

    }

}
</script>
